import React from 'react';
import { Box, Skeleton, useMediaQuery, useTheme } from '@mui/material';
import 'react-alice-carousel/lib/alice-carousel.css'; // requires a loader
import AliceCarousel from 'react-alice-carousel';
import { useSelector } from 'react-redux';
const Carousels = () => {
	const { populardesc } = useSelector((state) => state.home);
	const theme = useTheme();
	const matches = useMediaQuery(theme.breakpoints.down('sm'));
	const responsive = {
		0: { items: 1 },
		568: { items: 2 },
		1024: { items: 4 },
	};
	const items = populardesc?.banner.map((i, index) => {
		return (
			<div className='item' data-value='1' style={{ marginTop: 20 }}>
				<div
					style={{
						backgroundImage: `url(${i.imgpath})`,
						backgroundSize: 'cover',
						width: '250px',
						height: '250px',
						cursor: 'pointer',
					}}>
					<h2
						style={{
							position: 'absolute',
							textAlign: 'center',
							left: '30%',
							top: '39%',
							fontSize: '30px',
							color: 'white',
							fontWeight: 'bold',
							zIndex: 1,
						}}>
						{i.destination}
					</h2>
					<div className='blackLayer'></div>
				</div>
			</div>
		);
	});
	const demo = [
		<Skeleton
			variant='rectangular'
			width={'100%'}
			height={180}
			style={{ marginLeft: 10 }}
		/>,
		<Skeleton
			variant='rectangular'
			width={'100%'}
			height={180}
			style={{ marginLeft: 20 }}
		/>,
		<Skeleton
			variant='rectangular'
			width={'100%'}
			height={180}
			style={{ marginLeft: 30 }}
		/>,
		<Skeleton
			variant='rectangular'
			width={'100%'}
			height={180}
			style={{ marginLeft: 40 }}
		/>,
		<Skeleton
			variant='rectangular'
			width={'100%'}
			height={180}
			style={{ marginLeft: 50 }}
		/>,
		<Skeleton
			variant='rectangular'
			width={'100%'}
			height={180}
			style={{ marginLeft: 60 }}
		/>,
	];
	const item = [0, 1, 2];
	return (
		<AliceCarousel
			autoPlay
			infinite
			mouseTracking
			items={populardesc?.banner?.length > 0 ? items : demo}
			autoPlayInterval={3000}
			responsive={responsive}
			controlsStrategy='alternate'
			keyboardNavigation={true}
			renderPrevButton={() => {
				return <p></p>;
			}}
			renderNextButton={() => {
				return <p></p>;
			}}
		/>
	);
};

export default Carousels;
